import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import moment from 'moment'
import Useful from '@/api/useful'
import Circles from '@/api/circles'
import Params from '@/api/params'
import AuthApi from '@/api/auth'
import Auth from '@/plugins/auth'

Vue.use(Vuex)

export const state = () => ({
    locales: [],
    locale: 'fr',
    folangs: [],
    men_logo: null,
    cities: [],
    destination: null,
    circles: [],
    filters: {}
})

export const mutations = {
    SET_LANG (state, locale) {
        if (state.locales && state.locales.indexOf(locale) !== -1) {
            state.locale = locale
            axios.defaults.headers['accept-language'] = locale
            moment.locale(locale)
            let user = JSON.parse(localStorage.getItem('user'))
            if (user) {
                user.lang_id = locale
                localStorage.setItem('user', JSON.stringify(user))
            }
        } else {
            state.locale = 'fr'
            axios.defaults.headers['accept-language'] = 'fr'
            moment.locale('fr')
            let user = JSON.parse(localStorage.getItem('user'))
            if (user) {
                user.lang_id = 'fr'
                localStorage.setItem('user', JSON.stringify(user))
            }
        }
    },
    LOAD_LANGS (state) {
        Useful.getFoLangs().then(res => {
            let out = []
            let out2 = []
            let iso = []
            var context = require.context("@/locales/", true, /\.json$/)

            //On check quels fichiers locales on a
            context.keys().forEach(function (key) {
                let path = key
                let tb1 = path.split('./')
                let name = tb1[1]
                let tb2 = name.split('.json')
                let l = tb2[0]
                iso.push(l)
            })

            if (res && res.data) {
                for (let i = 0; i < res.data.length; i++) {
                    if (iso.indexOf(res.data[i].id) > -1) {
                        out.push(res.data[i].id)
                        res.data[i]['name'] = JSON.parse(res.data[i]['name'])
                        out2.push(res.data[i])
                    }
                }
            }
            state.locales = out
            state.folangs = out2
        })
    },
    LOAD_LOGO (state) {
        if (!state.men_logo) {
            Params.getList('params').then(res => {
                for (let i = 0; i < res.data.length; ++i) {
                    const p = res.data[i]

                    if (p.name == 'men_logo_id') {
                        axios.get('/assets/logoMen/' + p.value, p.value).then(res => {
                            state.men_logo = res.data
                        })
                        break
                    }
                }
            })
        }
    },
    LOAD_CITIES (state) {
        if (!state.cities || !state.cities.length) {
            Useful.getCities().then(res => {
                state.cities = res.data
            })
        }
    },
    SET_TUTO () {
        let user = JSON.parse(localStorage.getItem('user'))
        user.skip_tuto = 1
        localStorage.setItem('user', JSON.stringify(user))
        Auth.user.skip_tuto = 1
        AuthApi.skipTuto()
    },
    ADD_DESTINATION (state, destination) {
        state.destination = destination
    },
    CLEAR_DESTINATION (state) {
        state.destination = null
    },
    SET_CIRCLE_INFO () {
        let user = JSON.parse(localStorage.getItem('user'))
        user.circle_info = 0
        localStorage.setItem('user', JSON.stringify(user))
        Auth.user.circle_info = 0
        AuthApi.hideCircleInfo()
    },
    LOAD_CIRCLES (state, force = false) {
        if (!state.circles || !state.circles.length || force) {
            Circles.followings().then(res => {
                state.circles = res.data
            })
        }
    },
    SET_FILTERS(state, filters) {
      let data = null
      const json = localStorage.getItem('filters')
      if (json) {
        data = JSON.parse(json)
      } else {
        data = {}
      }

      data[filters.key] = filters.data
      localStorage.setItem('filters', JSON.stringify(data))
    }
}

export const getters = {
  getFilters: () => (key) => {
    const json = localStorage.getItem('filters')
    if (json) {
      const filters = JSON.parse(json)
      if (filters[key]) {
        return filters[key]
      }
    }
    return null
  }
}

export const store = new Vuex.Store({
    state,
    mutations,
    getters
})
